"use strict";

module.exports = {
  mandatory: function mandatory(mandatoryFields, method) {
    console.log(mandatoryFields, method); // TODO
  },
  albumName: function albumName(name) {
    return /^[a-z0-9_-]+$/i.test(name);
  }
};